/**
 * クッキーの値を取得する
 * @param {String} searchKey 検索するキー
 * @returns {String} キーに対応する値
 */
export function getCookieValue (cName) {
    var cookie_name = cName;
    if(cookie_name === '' || cookie_name == null) {
        console.log('COOKIES.getCookie：引数に値を代入してください。');
    } else {
        var set_replace = '(?:(?:^|.*\s*)' + cookie_name + '\s*\=\s*([^;]*).*$)|^.*$';
        return document.cookie.replace(new RegExp(set_replace), '$1');
    }
}

export function setCookie(cookieName, cookieValue, days ){
    var dateObject = new Date();
    dateObject.setTime( dateObject.getTime() + ( days*24*60*60*1000 ) );
    var expires = "expires=" + dateObject.toGMTString();
    var path = "path=/";
    document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; " + path;
}

export function getDateAgo(date, days) {
    date.setDate(date.getDate() - days);
    return date.getTime();
}

export const OK = 200
export const CREATED = 201
export const INTERNAL_SERVER_ERROR = 500
export const UNPROCESSABLE_ENTITY = 422
export const UNAUTHORIZED = 401

export const apiUrl = {
    'updatePhoto' : 'api/updatePhoto'
}